import React from 'react';
import { Alert } from "react-bootstrap";

const LoginLayout = ({children, error}) => {
    return ( 
        <>
            <div className="container">               
                <div className="row justify-content-center"> 
                    <div className="col-xl-10 col-lg-12 col-md-9"> 
                        <div className="card o-hidden border-0 shadow-lg my-5">
                            <div className="card-body p-0">                              
                                <div className="row size-box">
                                        <div className="col-lg-6 d-none d-lg-block bg-login-image"></div>
                                        <div className="col-lg-6">
                                        <div className="p-5 middle-screen">
                                            <div className="text-center">
                                                <h1 className="h4 text-gray-900 mb-4">Login</h1>
                                                {!error? null : 
                                                    <Alert variant={'danger'}>
                                                        {error}
                                                    </Alert>
                                                }
                                            </div>                                               
                                                {children}
                                        </div>
                                      
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
     );
}
 
export default LoginLayout;